import i18n from '@/lang';
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.object.to-string.js";
export default [{
  path: '/project',
  name: 'Project',
  component: function component() {
    return import('@/pages/project/entry');
  },
  meta: {
    name: i18n.tc("132")
  }
}, {
  path: '/projectBelong',
  name: 'ProjectBelong',
  props: function props(route) {
    return route.query;
  },
  component: function component() {
    return import('@/pages/project/entry');
  },
  meta: {
    name: i18n.tc("132")
  }
}, {
  path: '/project/detail/:oid',
  name: 'ProjectDetail',
  props: true,
  component: function component() {
    return import('@/pages/project/detail');
  },
  meta: {
    name: i18n.tc("133")
  }
}, {
  path: '/project/detail/comment/:oid',
  name: 'ProjectDetailComment',
  props: function props(route) {
    return {
      oid: route.params.oid,
      anonymity: 1
    };
  },
  component: function component() {
    return import('@/pages/project/detail/OrderBottomOptions/GeneralEvaluate');
  },
  meta: {
    name: i18n.tc("134")
  }
}, {
  path: '/project/detail/message/:id/:customer_id',
  name: 'ProjectDetailMessage',
  props: true,
  component: function component() {
    return import('@/pages/project/detail/message');
  },
  meta: {
    name: i18n.tc("135")
  }
}, {
  path: '/order/receipt/:oid',
  name: 'GeneraExecute',
  props: true,
  component: function component() {
    return import('@/pages/project/detail/OrderReturnReceipt/GeneraExecute');
  },
  meta: {
    name: i18n.tc("136")
  }
}, {
  path: '/returnVisit/task/:oid',
  name: 'GeneraVisit',
  props: true,
  component: function component() {
    return import('@/pages/project/detail/OrderRetrunVisit/GeneraVisit');
  },
  meta: {
    name: i18n.tc("136")
  }
}];